import { SVGProps } from "react";

const BitGetIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
            <g clipPath="url(#clip0_90_2)">
                <rect width="40" height="40" fill="#00F0FF" />
                <path d="M31.2891 0H8.71094C3.90002 0 0 3.90002 0 8.71094V31.2891C0 36.1 3.90002 40 8.71094 40H31.2891C36.1 40 40 36.1 40 31.2891V8.71094C40 3.90002 36.1 0 31.2891 0Z" fill="#00F0FF" />
                <path d="M18.4596 15.7671H25.9282L33.5686 23.3587C34.0656 23.8525 34.0682 24.6558 33.5737 25.1521L23.7753 35H16.0816L18.4076 32.7387L26.9476 24.2526L18.516 15.7664" fill="#1B1B1B" />
                <path d="M21.5292 24.2336H14.0606L6.4202 16.6419C5.92318 16.1481 5.92064 15.3449 6.41512 14.8485L16.2135 5H23.9072L21.5812 7.26132L13.0412 15.7474L21.4728 24.2336" fill="#1B1B1B" />
            </g>
            <defs>
                <clipPath id="clip0_90_2">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default BitGetIcon